<script setup lang="ts">
defineOptions({
	name: 'IconMedicineHeart',
})

interface Props {
	class?: string
	classIcon?: string
}

const props = withDefaults(defineProps<Props>(), {
	class: 'text-neutral-50',
	classIcon: 'w-8 h-8',
})
</script>

<template>
	<svg
		:class="[props.class, props.classIcon]"
		viewBox="0 0 31 31"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M3.08789 15.715H5.01289"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M26.2629 15.715H28.0879"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M6.75038 24.5523L8.11288 23.1898"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M23.1379 8.16482L24.4254 6.87732"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M15.5879 28.2149V26.2899"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M15.5879 5.03984V3.21484"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M24.4254 24.5523L23.0629 23.1898"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M8.03788 8.16482L6.75038 6.87732"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M16.0266 12.7911L15.5879 13.2573L15.1491 12.7911C14.1866 11.7686 12.5904 11.6848 11.5254 12.5998V12.5998C10.4379 13.5348 10.3079 15.1561 11.2029 16.2786C12.4829 17.8836 13.9504 19.4673 15.5879 20.7148C17.2666 19.4373 18.7654 17.8048 20.0679 16.1586C20.9129 15.0898 20.7404 13.5386 19.7066 12.6498L19.6591 12.6086C18.5866 11.6848 16.9891 11.7686 16.0266 12.7911V12.7911Z"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
